import { FC } from "react";
import { Toolbar } from "@mui/material";
import {
    SplitButton, SubmitButton,
} from "@websential/cosmic-v20";

export interface IEarningSummarySetupToolbar {
    onSaveButtonClickHandler: (selectedItem: any) => void;
}

export const EarningSummarySetupToolbar: FC<IEarningSummarySetupToolbar> = ({
    onSaveButtonClickHandler
}) => {
    return (
        <Toolbar>
            <>
                <SplitButton
                    options={["Save", "Save + Payroll"]}
                    onClickHandler={onSaveButtonClickHandler}
                    testId="earning-summary-button"
                />
            </>
        </Toolbar>
    );
};
